import { axios_institute_private } from "../../../../api/setup.intersepter";

export const GetAttendanceData = (
  id: string,
  timestamp: number,
  branchId: string,
  userId: string
) => {
  let url = `/studentAttendance?instituteId=${id}&timestamp=${timestamp}`;
  if (branchId) {
    url += `&branchId=${branchId}`;
  }
  if (userId) {
    url += `&userId=${userId}`;
  }
  return axios_institute_private({
    method: "GET",
    url: url,
  });
};

export const GetAttendanceCalendarMarkers = (
  id: string,
  startDate: number,
  endDate: number,
  branchId: string,
  userId: string
) => {
  let url = `/studentAttendance?instituteId=${id}&startDate=${startDate}&endDate=${endDate}
`;
  if (branchId) {
    url += `&branchId=${branchId}`;
  }
  if (userId) {
    url += `&userId=${userId}`;
  }

  return axios_institute_private({
    method: "GET",
    url: url,
  });
};

export const getAttendanceStudentList = (
  batchId: string,
  attendanceDate: any,
  batchStartTime: any,
  batchEndTime: any
) => {
  return axios_institute_private({
    method: "GET",
    url: `/studentAttendance?batchId=${batchId}&attendanceDate=${attendanceDate}&batchStartTime=${batchStartTime}&batchEndTime=${batchEndTime}`,
  });
};

export const saveStudentAttendance = (body: any) => {
  return axios_institute_private({
    method: "POST",
    url: `/studentAttendance`,
    data: body,
  });
};

export const editStudentAttendance = (body: any) => {
  return axios_institute_private({
    method: "PUT",
    url: `/studentAttendance`,
    data: body,
  });
};
